import React, { useEffect, useState } from 'react';
import { MemoryRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { CircularProgress } from '@mui/material';
import { StyledCardSection, StepsRouter } from '@fnol/library/src/components';
import { constValues } from '@fnol/library/src/lib';
import { authClient } from '@fnol/library/src/api/auth';
import stepsComposer from '../../lib/stepsComposer';
import { personalDocumentType } from '../../lib/consts';
import { submitTemporaryData } from '../../rpc/actions';
import { prepareDataForSubmit } from '../../lib/helpers';

const LifeApp = () => {
    const [loggedIn, setLoggedIn] = useState<boolean>(false);
    useEffect(() => {
        authClient.login('life', 235).then(() => setLoggedIn(true));
    }, []);

    return (
        <>
            {loggedIn ? (
                <Formik
                    enableReinitialize
                    initialValues={{
                        policyNumber: '', // policy detail screen
                        offerNumber: '', // policy detail screen
                        insuredPersonUCN: '', // policy detail screen
                        contractorUCN: '', // policy detail screen
                        policyNumberOfferNumberOrUCN: '', // policy detail screen
                        activePolicies: [], // policy detail screen
                        activePolicyNumber: '', // policy detail screen
                        activePolicy: null, // policy detail screen
                        policyNotFound: '', // policy detail screen
                        dateOfOccurance: '', // policy detail screen
                        risks: [], // policy detail screen
                        calculationItems: [], // policy detail screen
                        // risk: riskType.initialValue, // policy detail screen

                        uploadDocList: [], //policy documents screen

                        submitterRole: '', // submitter detail screen
                        submitterName: '', // submitter detail screen
                        submitterLastName: '', // submitter detail screen
                        submitterEmail: '', // submitter detail screen
                        submitterPhone: constValues.dialCodeSerbia, // submitter detail screen
                        agreementContract: '', // submitter detail screen
                        agreementDocumentation: '', // submitter detail screen
                        agreementSMS: '', // submitter detail screen
                        agreementEmail: '', // submitter detail screen
                        agreementData: '', // submitter detail screen
                        agreementDataForContract: false, // submitter detail screen
                        agreementObligation: false, // submitter detail screen

                        isSubmitterUser: '',
                        submitterDateOfBirth: '', // submitter detail screen
                        submitterUCN: '', // submitter detail screen
                        submitterCitizenship: '', // submitter detail screen
                        submitterCountry: constValues.countrySerbiaId, // submitter detail screen
                        submitterDualCitizenship: '', // submitter detail screen
                        submitterMyCountry: '', // submitter detail screen
                        submitterCity: '', // submitter detail screen
                        submitterCityInSerbia: '', // submitter detail screen
                        submitterZipCode: '', // submitter detail screen
                        submitterStreet: '', // submitter detail screen
                        submitterMunicipality: '', // submitter detail screen
                        submitterPersonalDocumentType: personalDocumentType.initialValue, // submitter detail screen
                        submitterPersonalDocumentNumber: '', // submitter detail screen
                        submitterDocumentIssuePlace: '', // submitter detail screen
                        submitterDocumentIssueDate: '', // submitter detail screen
                        submitterStatement: '', // submitter detail screen
                        submitterStatementNote: '', // submitter detail screen
                        submitterPlaceOfBirth: '', // submitter detail screen
                        submitterGender: '', // submitter detail screen
                        submitterCurrentResidenceAddress: '', // submitter detail screen
                        submitterCurrentResidenceStreet: '', // submitter detail screen
                        submitterCurrentResidenceMunicipality: '', // submitter detail screen
                        submitterCurrentResidenceCity: '', // submitter detail screen
                        submitterCurrentResidenceCityInSerbia: '', // submitter detail screen
                        submitterCurrentResidenceZipCode: '', // submitter detail screen
                        submitterMailingAddress: '', // submitter detail screen
                        submitterMailingStreet: '', // submitter detail screen
                        submitterMailingMunicipality: '', // submitter detail screen
                        submitterMailingCity: '', // submitter detail screen
                        submitterMailingCityInSerbia: '', // submitter detail screen
                        submitterMailingZipCode: '', // submitter detail screen
                        submitterAttorneySignature: false, // submitter detail screen

                        description: '', // claim detail screen
                        typeOfInjury: '', // claim detail screen
                        investigation: '', // claim detail screen
                        surgicalInvestigation: '', // claim detail screen
                        hospitalDaysStart: '', // claim detail screen
                        hospitalDaysEnd: '', // claim detail screen
                        firstAid: '', // claim detail screen
                        physicalFlaw: '', // claim detail screen
                        sameInjury: '', // claim detail screen
                        hospitalType: '', // claim detail screen
                        firstContactDate: '', // claim detail screen
                        medicalRecord: '', // claim detail screen
                        diagnosis: '', // claim detail screen
                        surgicalIntervention: '', // claim detail screen
                        prohibitedSubstances: '', // claim detail screen
                        hospitalOfSurgical: '', // claim detail screen
                        dateOfFirstContact: '', // claim detail screen
                        cause: '', // claim detail screen
                        deathCause: '', // claim detail screen
                        drName: '', // claim detail screen
                        institutionName: '', // claim detail screen
                        dateOfSeriousIllness: '', // claim detail screen
                        diagnosisSeriousIllness: '', // claim detail screen
                        seriousIllnessTreatment: '', // claim detail screen
                        paymentComment: '', // claim detail screen

                        userName: '', // users detail screen
                        userLastName: '', // users detail screen
                        userDateOfBirth: '', // users detail screen
                        userUCN: '', // users detail screen
                        userCitizenship: '', // users detail screen
                        userCountry: constValues.countrySerbiaId, // users detail screen
                        userDualCitizenship: '', // users detail screen
                        userMyCountry: '', // users detail screen
                        userCity: '', // users detail screen
                        userCityInSerbia: '', // users detail screen
                        userZipCode: '', // users detail screen
                        userStreet: '', // users detail screen
                        userMunicipality: '', // users detail screen
                        userEmail: '', // users detail screen
                        userPhone: constValues.dialCodeSerbia, // users detail screen
                        userPersonalDocumentType: personalDocumentType.initialValue, // users detail screen
                        userPersonalDocumentNumber: '', // users detail screen
                        userDocumentIssuePlace: '', // users detail screen
                        userDocumentIssueDate: '', // users detail screen
                        userStatement: '', // users detail screen
                        userStatementNote: '', // users detail screen
                        userPlaceOfBirth: '', // users detail screen
                        userGender: '', // users detail screen
                        userCurrentResidenceAddress: '', // users detail screen
                        userCurrentResidenceStreet: '', // users detail screen
                        userCurrentResidenceMunicipality: '', // users detail screen
                        userCurrentResidenceCity: '', // users detail screen
                        userCurrentResidenceCityInSerbia: '', // users detail screen
                        userCurrentResidenceZipCode: '', // users detail screen
                        userMailingAddress: '', // users detail screen
                        userMailingStreet: '', // users detail screen
                        userMailingMunicipality: '', // users detail screen
                        userMailingCity: '', // users detail screen
                        userMailingCityInSerbia: '', // users detail screen
                        userMailingZipCode: '', // users detail screen
                        userAttorneySignature: false, // users detail screen

                        paymentToUser: '', // payment detail screen
                        outliveFullPayment: '', // payment detail screen
                        outliveTransfer: '', // payment detail screen
                        transferType: '', // payment detail screen
                        transferOffer1Number: '', // payment detail screen
                        transfer1Amount: '', // payment detail screen
                        thirdPersonName: '', // payment detail screen
                        thirdPersonLastName: '', // payment detail screen
                        thirdPersonDateOfBirth: '', // payment detail screen
                        thirdPersonUCN: '', // payment detail screen
                        thirdPersonCitizenship: '', // payment detail screen
                        thirdPersonCountry: constValues.countrySerbiaId, // payment detail screen
                        thirdPersonDualCitizenship: '', // payment detail screen
                        thirdPersonMyCountry: '', // payment detail screen
                        thirdPersonCity: '', // payment detail screen
                        thirdPersonCityInSerbia: '', // payment detail screen
                        thirdPersonZipCode: '', // payment detail screen
                        thirdPersonStreet: '', // payment detail screen
                        thirdPersonMunicipality: '', // payment detail screen
                        thirdPersonEmail: '', // payment detail screen
                        thirdPersonPhone: constValues.dialCodeSerbia, // payment detail screen
                        thirdPersonPersonalDocumentType: personalDocumentType.initialValue, // payment detail screen
                        thirdPersonPersonalDocumentNumber: '', // payment detail screen
                        thirdPersonDocumentIssuePlace: '', // payment detail screen
                        thirdPersonDocumentIssueDate: '', // payment detail screen
                        thirdPersonStatement: '', // payment detail screen
                        thirdPersonStatementNote: '', // payment detail screen
                        thirdPersonPlaceOfBirth: '', // payment detail screen
                        thirdPersonGender: '', // payment detail screen
                        thirdPersonCurrentResidenceAddress: '', // payment detail screen
                        thirdPersonCurrentResidenceStreet: '', // payment detail screen
                        thirdPersonCurrentResidenceMunicipality: '', // payment detail screen
                        thirdPersonCurrentResidenceCity: '', // payment detail screen
                        thirdPersonCurrentResidenceCityInSerbia: '', // payment detail screen
                        thirdPersonCurrentResidenceZipCode: '', // payment detail screen
                        thirdPersonMailingAddress: '', // payment detail screen
                        thirdPersonMailingStreet: '', // payment detail screen
                        thirdPersonMailingMunicipality: '', // payment detail screen
                        thirdPersonMailingCity: '', // payment detail screen
                        thirdPersonMailingCityInSerbia: '', // payment detail screen
                        thirdPersonMailingZipCode: '', // payment detail screen

                        users: [], // payment detail screen
                        submitError: '', // payment detail screen
                        tempID: '',
                        oneTimePass: '',
                        skipSteps: [],
                    }}
                    onSubmit={(values, { setFieldValue, setSubmitting }) => {
                        submitTemporaryData(prepareDataForSubmit(values))
                            .then((response) => {
                                setFieldValue('tempID', response.data);
                                setFieldValue('submittedSuccessfully', true);
                                setFieldValue('submitError', '');
                                setSubmitting(false);
                            })
                            .catch((error) => {
                                setFieldValue('submittedSuccessfully', false);
                                setFieldValue('submitError', error.response?.data);
                                setSubmitting(false);
                            });
                    }}
                >
                    {({ values }) => (
                        <Form>
                            <MemoryRouter>
                                <StyledCardSection>
                                    <StepsRouter steps={stepsComposer()} skipSteps={values.skipSteps} />
                                </StyledCardSection>
                            </MemoryRouter>
                        </Form>
                    )}
                </Formik>
            ) : (
                <CircularProgress />
            )}
        </>
    );
};

export default LifeApp;
